import { useRecordContext } from 'ra-core';

export const SaleName = ({ sale }: { sale?: any } = {}) => {
  const record = useRecordContext();
  const data = sale || record;

  if (!data) return null;

  return <span>{data.name || data.sale_number || data.nome_consorciado || '-'}</span>;
};
